class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    const bubble = document.querySelector('.cart-count-bubble');
    const hadSeasonal = bubble?.classList.contains('has_seasonal');

    // セクションの更新
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id);
      if (elementToReplace) {
        elementToReplace.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });

    // seasonal-fee がある場合の -1 処理
    if (bubble && hadSeasonal) {
      const countEl = document.querySelector('.cart-count-bubble span');
      const cartButton = document.getElementById('cart-notification-button');

      if (countEl && cartButton) {
        const current = parseInt(countEl.textContent, 10);
        const newCount = Math.max(current - 1, 0); // -1

        // 両方を同じ newCount に更新
        countEl.textContent = newCount;
        cartButton.textContent = cartButton.textContent.replace(/\(\d+\)/, `(${newCount})`);
      }

      bubble.classList.add('has_seasonal'); // 再付与
    }

    if (this.header) this.header.reveal();
    this.open();
  }


  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
